<template>
    <div
      class="modal right fade trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >EDIT ACCOUNTS : {{accountMultipleData.map((data) => {return data.account}).join(', ')}}</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <span style="font-weight:500;color: #0087D4;">SELECTED ACCOUNTS : {{accountMultipleData.map((data) => {return data.account}).toString()}}</span> -->
            <form>
              <!-- <div class="form-row">
                  <div class="col-md-6">
                      <label for="accountno">Is Margin</label>
                      <div class="input-group mb-3">
                          <select class="form-control"  v-model="accountData.isMargin" >
                              <option value="YES">YES</option>
                              <option value="NO">NO</option>
                          </select>
                      </div>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-md-6" >
                      <label for="accountno">PMP</label>
                      <div class="input-group mb-3">
                          <select class="form-control"  v-model="accountData.pmp" >
                              <option value="YES">YES</option>
                              <option value="NO">NO</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <label for="accountno">FBSI Short Name</label>
                      <div class="input-group mb-3">
                          <input  type="text" class="form-control" id="accountno" placeholder="FBSI Short Name" v-model="accountData.fbsiShortName">
                      </div>
                  </div>
              </div> -->
              <div class="form-row"> 
                  <div class="col-md-6" >
                      <label for="accountno">MATURITY</label>
                      <div class="input-group mb-3">
                          <select class="form-control"  v-model="maturity" >
                              <option value="">Please Select</option>
                              <option value="Short">Short</option>
                              <option value="Medium">Medium</option>
                              <option value="Long">Long</option>
                              <option value="All">All</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6" >
                      <label for="accountno">SPREAD</label>
                      <div class="input-group mb-3">
                          <select class="form-control"  v-model.number="spread" >
                              <option value="">Please Select</option>
                              <option value="0.5">0.5</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6" >
                      <label for="accountno">CONTACT</label>
                      <div class="input-group mb-3">
                          <select class="form-control"  v-model="contact" >
                              <option value="">Please Select</option>
                              <option value="YES">YES</option>
                              <option value="NO">NO</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6" >
                      <label for="accountno">EOD</label>
                      <div class="input-group mb-3">
                          <select class="form-control"  v-model="eod" >
                             <option value="">Please Select</option>
                              <option value="YES">YES</option>
                              <option value="NO">NO</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6" >
                      <label for="accountno">PRIMARY REP</label>
                      <div class="input-group mb-3">
                        <multiselect 
                            v-model="primaryRep" 
                            placeholder="Select" 
                            :options="representativeData" 
                            :multiple="false" 
                            label="firstName" 
                            track-by="id" >
                            </multiselect>
                          <!-- <select class="form-control"  v-model="primaryRepId" >
                              <option v-for="rep in representativeData" :key="rep.id" :value="rep.id">{{ rep.firstName }}</option>
                          </select> -->
                      </div>
                  </div>
                  <div class="col-md-6" >
                      <label for="accountno">SECONDARY REP</label>
                      <div class="input-group mb-3">
                        <multiselect 
                            v-model="secondaryRep" 
                            placeholder="Select" 
                            :options="representativeData" 
                            :multiple="false" 
                            label="firstName" 
                            track-by="id" >
                            </multiselect>
                          <!-- <select class="form-control"  v-model="secondaryRepId" >
                            <option v-for="rep in representativeData" :key="rep.id" :value="rep.id">{{ rep.firstName }}</option>
                          </select> -->
                      </div>
                  </div>
                  <div class="col-md-6" >
                      <label for="accountno">ACTIVE ACCOUNT</label>
                      <div class="input-group mb-3">
                          <select class="form-control"  v-model="activeAccount" >
                             <option value="">Please Select</option>
                              <option value="YES">YES</option>
                              <option value="NO">NO</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <label for="accountno">NOTE</label>
                      <div class="input-group mb-3">
                          <textarea  class="form-control" v-model.trim="note" rows="3" maxlength="750"></textarea>
                      </div>
                  </div>
                  
              </div>    
              <p v-if="errors.length">
                  <ul>
                  <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                  </ul>
              </p>
              <div class="modal-footer bid">
                  <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                  <button type="button" class="btn btn-primary" @click="updateAccount()">UPDATE</button>
              </div>
          </form>
          <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import authService from "@/authService";
  import config from "@/config";

  export default {
      name: 'moneyLineEditmodal',
      components :{
          
      },
      props: ['accountMultipleData'],
      data() {
          return {
              loading : false,
              errors: [],
              maturity : "",
              spread : "",
              contact : "",
              eod : "",
              activeAccount : "",
              note : null,
              primaryRepId : "",
              secondaryRepId : "",
              representativeData : [],
              primaryRep : null,
              secondaryRep : null,
          };
      },
      methods: { 
          updateAccount(){
              let isValid = this.checkForm();
              if (isValid) {
                  let dataToSend = {};
                    if(this.contact  == 'YES'){
                        dataToSend.contact  = true
                    }else if(this.contact  == 'NO'){
                        dataToSend.contact  = false
                    }else{
                        dataToSend.contact = null
                    }

                    if(this.eod  == 'YES'){
                        dataToSend.eod  = true
                    }else if(this.eod  == 'NO'){
                        dataToSend.eod  = false
                    }else{
                        dataToSend.eod = null
                    }

                    if(this.activeAccount  == 'YES'){
                        dataToSend.export  = true
                    }else if(this.activeAccount  == 'NO'){
                        dataToSend.export  = false
                    }else{
                        dataToSend.export = null;
                    }
                    dataToSend.maturity = this.maturity ? this.maturity : null;
                    dataToSend.spread = this.spread ? this.spread : null;
                    dataToSend.note = this.note ? this.note : null;
                    dataToSend.accountUpdateIdList = this.accountMultipleData.map((data) => {return data.id})
                    dataToSend.primaryRepId = this.primaryRep ? this.primaryRep.id : null
                    dataToSend.secondaryRepId = this.secondaryRep ? this.secondaryRep.id : null
                var message = `Selected accounts will be updated`;
                this.$confirm(message,"Are You Sure","question",{confirmButtonText:"UPDATE",cancelButtonText : "NO"}).then(() => {
                  const auth = {
                      headers: { 'org-token' : authService.getOrgToken()  }
                  };
                  this.loading = true;
                  this.$http
                  .put(config.baseUrlBidSide + "/account/update-all?cognitoSub="+authService.getUser().cognitoSub, dataToSend, auth)
                  .then(() => {
                      this.loading = false;  
                      this.$alert("Successfully Updated","","success");
                      this.$emit('close');               
                  })
                  .catch(() => {
                      this.loading = false;              
                  });
                })
              }
          },
          checkForm(){
              this.errors = [];
              if(this.primaryRep && this.secondaryRep)
                    if (this.primaryRep.id === this.secondaryRep.id) {
                        this.errors.push("Primary and secondary representative can't be same");
                        return false;
                    }
              return true
          },
          getRepresentativeList() {
            this.loading = true;
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            let url = "/money-line/representative-list";
            this.$http
                .get(
                config.baseUrlAutoBidder +
                    url,
                    auth
                )
                .then(result => {
                this.representativeData = result.data
                this.loading = false;
                })
            }


      },
      created(){
          this.getRepresentativeList();

      }
  };
  </script>
  <style>
  .modal .form-control{
      height: auto;
  }
  .is-margin{
      margin: 37px;
  }
  </style>